import React, { useState } from 'react';

// GIF & Static Image Imports
import gif1 from '../Assets/Gif/01service.gif';
import gif2 from '../Assets/Gif/02service.gif';
import gif3 from '../Assets/Gif/03service.gif';
import gif4 from '../Assets/Gif/04service.gif';
import gif5 from '../Assets/Gif/05service.gif';
import gif6 from '../Assets/Gif/06service.gif';
import gif7 from '../Assets/Gif/07service.gif';
import gif8 from '../Assets/Gif/08service.gif';
import gif9 from '../Assets/Gif/09service.gif';

import static1 from '../Assets/Gif/01-service-static.png';
import static2 from '../Assets/Gif/02-service-static.png';
import static3 from '../Assets/Gif/03-service-static.png';
import static4 from '../Assets/Gif/04-service-static.png';
import static5 from '../Assets/Gif/05-service-static.png';
import static6 from '../Assets/Gif/06-service-static.png';
import static7 from '../Assets/Gif/07-service-static.png';
import static8 from '../Assets/Gif/08-service-static.png';
import static9 from '../Assets/Gif/09-service-static.png';

const ServicesSection = () => {
  const [hoverIndex, setHoverIndex] = useState(null);

  const services = [
    {
      title: 'Social Media Managment',
      text: <>We spin strategy like Spider-Man slings webs — fast, sticky, and impossible to ignore. Welcome to your brand’s very own social super-suit.</>,
      gif: gif1,
      static: static1,
      reverse: false,
    },
    {
      title: 'Web Development',
      text: <>Built like Cap’s shield — fast, secure, and beautifully indestructible. Your website won’t just look good, it’ll lead the charge.</>,
      gif: gif2,
      static: static2,
      reverse: true,
    },
    {
      title: 'Reels Production',
      text: <>Think Stormbreaker but for content — every cut hits hard, every frame strikes viral. Your brand’s thunder starts here.</>,
      gif: gif3,
      static: static3,
      reverse: false,
    },
    {
      title: 'Podcast Shoot',
      text: <>Shot with precision like Hawkeye, delivered with Stark’s tech. Because your voice deserves more than just a mic — it needs a cinematic echo.</>,
      gif: gif4,
      static: static4,
      reverse: true,
    },
    {
      title: 'Performance Marketing',
      text: <>Like Iron Man’s repulsors — laser-focused, data-powered, and built for impact. We don’t guess. We target.</>,
      gif: gif5,
      static: static5,
      reverse: false,
    },
    {
      title: 'Course Building',
      text: <>Wielding the Time Stone of content — we create value-packed, binge-worthy courses that teach, sell, and scale your expertise in any universe.</>,
      gif: gif6,
      static: static6,
      reverse: true,
    },
    {
      title: 'Branding',
      text: <>Crafted like Loki’s illusions — unforgettable, slick, and dangerously smart. Your brand won’t just stand out. It’ll stand above.</>,
      gif: gif7,
      static: static7,
      reverse: false,
    },
    {
      title: 'Video Production',
      text: <>Our content hits like Mjolnir — powerful, polished, and worthy of every screen. Lights, camera, brand impact.</>,
      gif: gif8,
      static: static8,
      reverse: true,
    },
    {
      title: 'Studio',
      text: <>Welcome to our version of Wakanda — tech-loaded, creatively charged, and always ready for your next big shoot.</>,
      gif: gif9,
      static: static9,
      reverse: false,
    },
    {
      title: 'Business Consultant',
      text: <>Guidance like Nick Fury — strategic, sharp, and two moves ahead. We don’t give advice, we build empires.</>,
      gif: gif9,
      static: static9,
      reverse: true,
    },
  ];

  return (
    <>
      <style>{`
        @media (max-width: 1024px) {
          .services-section {
            padding: 40px 20px !important;
          }
          .services-title {
            font-size: 44px !important;
            text-align: center !important;
          }
          .services-description {
            font-size: 16px !important;
            margin: 20px auto 0 auto !important;
            text-align: center !important;
          }
          .services-header {
            flex-direction: column !important;
            align-items: center !important;
          }
          .service-card {
            flex-direction: column !important;
            gap: 30px !important;
            text-align: center !important;
          }
          .service-textbox {
            padding: 0 !important;
          }
          .service-gifbox {
            justify-content: center !important;
            padding: 0 !important;
          }
        }

        @media (max-width: 600px) {
          .services-title {
            font-size: 34px !important;
          }
          .service-subheading {
            font-size: 22px !important;
          }
          .service-text {
            font-size: 15px !important;
          }
        }
      `}</style>

      <section
        className="services-section"
        style={{
          padding: '50px 100px',
          backgroundColor: '#fff',
          fontFamily: 'Montserrat, sans-serif',
        }}
      >
        {/* Header */}
        <div
          className="services-header"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            flexWrap: 'wrap',
            marginBottom: '50px',
          }}
        >
          <h1
            className="services-title"
            style={{
              marginTop: '35px',
              fontSize: '60px',
              lineHeight:'1.1',
              fontWeight: 800,
              margin: 0,
              flex: 1,
              
            }}
          >
            Our
            <br />
            Services
          </h1>

          <p
            className="services-description"
            style={{
              flex: 2,
              fontSize: '18px',
              lineHeight: 1.6,
              marginLeft: '28%',
              color: '#333',
            }}
          >
           These Aren’t Just Services  They’re Superpowers, Tailored for Your Brand.”<br/> We blend creativity, strategy, and tech to deliver bold social media marketing, precise ads management, viral reel production, and sleek website development all under one roof.

          </p>
        </div>

        {/* Cards */}
        {services.map((svc, index) => (
          <div
            key={index}
            className="service-card"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-around',
              flexWrap: 'wrap',
              marginBottom: '80px',
              flexDirection: svc.reverse ? 'row-reverse' : 'row',
            }}
          >
            <div className="service-textbox" style={{ flex: 1, padding: '0 20px' }}>
              <h2
                className="service-subheading"
                style={{ fontSize: '24px', fontWeight: 700, marginBottom: '15px' }}
              >
                {svc.title.split(' & ').map((part, idx) => (
                  <React.Fragment key={idx}>
                    {part}
                    {idx === 0 && svc.title.includes('&') ? ' & ' : ''}
                    <br />
                  </React.Fragment>
                ))}
              </h2>
              <p className="service-text" style={{ fontSize: '18px', color: '#333', lineHeight: 1.6 }}>
                {svc.text}
              </p>
            </div>

            <div
              className="service-gifbox"
              style={{ flex: 1, display: 'flex', justifyContent: 'center', padding: '0 20px' }}
              onMouseEnter={() => setHoverIndex(index)}
              onMouseLeave={() => setHoverIndex(null)}
            >
              <img
                src={hoverIndex === index ? svc.gif : svc.static}
                alt={svc.title}
                style={{
                  maxWidth: '100%',
                  height: 'auto',
                  borderRadius: '8px',
                }}
              />
            </div>
          </div>
        ))}
      </section>
    </>
  );
};

export default ServicesSection;
